import {
    cleanCommonParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
    mapTagsParams,
} from './common';

const mapHomeLinkParams = (
    isCreate,
    {
        platforms,
        products,
        sales_channels,
        search_phrase_ids,
        states,
        tags,
        expired_at,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            home_link: {
                ...cleanCommonParams(params),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                ...mapTagsParams(isCreate, tags),
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapHomeLinkParams };
